import styled from "@emotion/styled";

export const Container = styled.div`
    border: 2px solid #eeeeee;
    background-color: #f8f8f8;
    border-radius: 8px;
`;
export const Header = styled.div`
    margin-bottom: 1rem;
`;

export const Content = styled.div``;

export const Title = styled.div`
    font-size: .875rem;
    font-weight: 600;
    color: black;
    transform: translateY(2px);
    cursor: pointer;
`